import React from "react";

const socialContent = [
  {
    icon: "fa-facebook",
    link: "https://www.facebook.com/",
  },
  {
    icon: "fa-twitter",
    link: "https://twitter.com/",
  },
  {
    icon: "fa-linkedin",
    link: "https://www.linkedin.com/",
  },
];

const ContactAddress = () => {
  return (
    <div className="row justify-content-center">
      <div className="col-lg-6 col-sm-6 d-lg-flex">
        <div className="address-info">
          <div className="icon d-flex align-items-end">
            <img src="images/icon/44.svg" alt="icon" />
          </div>
          <div className="title">Địa chỉ</div>
          <p className="font-rubik">
          Tầng 2, CT2 Tràng An Complex,  <br /> Số 1 Phùng Chí Kiên, Nghĩa Đô, Cầu Giấy, Hà Nội
          </p>
        </div>{" "}
        {/* /.address-info  */}
      </div>
      {/* End .col */}

      <div className="col-lg-6 col-sm-6 d-lg-flex">
        <div className="address-info">
          <div className="icon d-flex align-items-end">
            <img src="images/icon/45.svg" alt="icon" />
          </div>
          <div className="title">Contact</div>
          <p className="font-rubik">
            hello@nkyc.vn <br />
            (84-4) 37930395 / (84-4) 37930395
          </p>
        </div>{" "}
        {/* /.address-info  */}
      </div>
      {/* End .col */}
      {/* End .col */}
    </div>
  );
};

export default ContactAddress;
